import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "She lives!",
  "description": "",
  "published": "2007-08-07T00:00:00.000Z",
  "redirect_from": ["/blog/she-lives/swizec/164"],
  "categories": "funny, life",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`On Sunday I was finally able to fix my computer after a very long time, I'm not even sure how long anymore and you know, I would've posted about it sooner, but I'm both lazy and busy and that's never a good combination for blogs as they tend to suffer a little.`}</p>
    <p>{`After the computer died I decided the problem wasin the mother board and a hunt began to find a mother board that supports all of my other antique hardware of three or four years ago. It's crazy, but there are absolutely no stores that are readily able to provide youw ith a mother board that still has an AGP port and IDE disk connectors.`}</p>
    <p>{`This is just silly! Do they expect me to swap everything from my RAM to my CPU and even disks just so I can buy a new mother board. Damn rabit capitalism and Moore's law of electronics and it's all getting quite out of hand if you ask me. Especially for us unrich people, especially for us. Why if anything ever breaks on my computer again I'll be left with only one option to chuck it out and cast it away like a broken plate nobody wants to look at again.`}</p>
    <p>{`Now here's the real kicker, I somehow managed to flip the pwoer supply upside-down and point the large 12 centimeter fan at a wall instead of into the computer where it can get air. How? I don't know.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      